import { render, staticRenderFns } from "./chooseGoods.vue?vue&type=template&id=4330da0e&"
import script from "./chooseGoods.vue?vue&type=script&lang=js&"
export * from "./chooseGoods.vue?vue&type=script&lang=js&"
import style0 from "./chooseGoods.vue?vue&type=style&index=0&id=4330da0e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports